import type { Styles } from '@adornis/ass/style.js';
import { XTab, XTabs } from '@adornis/chemistry/elements/components/x-tabs.js';
import { customElement, state } from 'lit/decorators.js';

/**
 * @customElement cr-tabs
 */
@customElement('cr-tabs')
export class ChromiumTabs extends XTabs {
  @state() override selectedColor = this.colors.secondary;

  // @ts-expect-error typing is wrong in base component
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        ':host': {
          maxWidth: 'unset !important',
        },
      },
    ];
  }
}
/**
 * @customElement cr-tab
 */
@customElement('cr-tab')
export class ChromiumTab extends XTab {
  @state() override selectedColor = this.colors.secondary;
  override styles() {
    return [
      {
        ':host': {
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'row',
          flex: '1',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          borderBottom: '2px solid transparent',

          userSelect: 'none',
        },
        ':host([selected])': { color: this.colors.secondary ? this.colors.secondary : this.colors.accent },
        ':host([secondary])': { fontWeight: 'lighter', fontSize: '12px' },
        ':host([big])': { height: '70px' },
        // '@media (max-width: 992px)': { height: '50px' },
        [`cr-h4`]: { width: 'unset' },
        '@media screen and (max-width: 500px)': {
          [`cr-h4`]: { fontSize: '14px' },
        },
      },
    ];
  }
}
